import React, {Component} from 'react';
import '../../style.css';
import {fetchPost, fetchPostFile} from "../../static/util/fetch";
import {Button, Form, Input, message, Modal, PageHeader, Space, Tag, Tooltip, Typography} from "antd";
import FileViewer from 'react-file-viewer';
const { Paragraph } = Typography;
class ReserveFund extends Component {
    constructor(props) {
        super(props);
        this.state = {
            companyId:this.props.companyId,
            companyName:this.props.companyName,
            organizationData:[
                {
                    time:'',
                    companyName:'',
                }
            ],
            para1:'',
            time:'',
            status:false,
            fileStream:'',
            preview_visible:false,
            fileStream_upload:'',
            fileField:[],
            upload_visible:false,
            uploadFile_visible:false,
            checkStatus:false,
        }
        this.hideModal = this.hideModal.bind(this);
    }
    componentDidMount() {
        fetchPost(global.constants.getQ4, {companyId:this.state.companyId})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            organizationData:res.data,
                            time:res.data.time,
                            companyName:res.data.companyName,
                            status:true
                        }))
                    }
                    else{
                        message.info("该材料未填写数据，请填写").then()
                        this.setState(()=>({
                            organizationData:[],
                            status:false
                        }))
                    }
                }
            )
    }
    edit(){
        fetchPost(global.constants.getQ4, {companyId:this.state.companyId})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            time:res.data.time,
                            companyName:res.data.companyName,
                            status:false,
                        }))
                    }
                }
            )
    }
    submit(){
        if(this.state.time === ''){
            message.info("请检查信息是否填写完整").then()
        }else{
            let params={
                companyId:this.state.companyId,
                companyName:this.state.companyName,
                time:this.state.time
            }
            fetchPost(global.constants.updateQ4,params)
                .then(
                    res => {
                        if(res.code === 200) {
                            message.success("添加成功").then()
                            fetchPost(global.constants.getQ4, {companyId:this.state.companyId})
                                .then(
                                    res => {
                                        if(res.code === 200) {
                                            this.setState(()=>({
                                                organizationData:res.data,
                                                time:res.data.time,
                                                companyName:res.data.companyName,
                                                status:true,
                                            }))
                                        }
                                    }
                                )
                        }
                    }
                )
        }
    }
    timeChange(e){
        const value = e.target.value
        this.setState(()=>({
            time:value
        }))
    }
    handleExportClick(){
        let params = {
            companyId:this.state.companyId
        }
        fetchPost(global.constants.exportQ4,params)
            .then(
                res => {
                    if(res.code === 200) {
                        message.success("已在云端生成，请下载").then()
                    }
                    else{
                        message.info("生成失败，请先添加数据").then()
                    }
                }
            )
    }
    download(){
        let params = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:0,
            otherId:0,
            remark:'',
            url: '/create/'+this.state.companyName+'/企业研发准备金制度.doc',
            fileName: '企业研发准备金制度.doc'
        }
        fetchPostFile(global.constants.downloadFile,params)
            .then(
                res=>{
                    res.blob().then(
                        blob=>{
                            let blobUrl = window.URL.createObjectURL(blob);
                            let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                            let filename = '企业研发准备金制度.doc';//设置文件名称
                            aElement.href = blobUrl;//设置a标签路径
                            aElement.download = filename;
                            aElement.click();
                            window.URL.revokeObjectURL(blobUrl);
                        }
                    )
                }
            )
    }
    hideModal(){
        this.setState(()=>({
            preview_visible:false,
            upload_visible:false,
        }))
    }
    handlePreviewClick(){
        let params={
            companyId:this.state.companyId,
            fileName:'企业研发准备金制度.doc'
        }
        fetchPost(global.constants.checkFileProcess, params)
            .then(
                res=> {
                    if (res.code === 200) {
                        let params = {
                            companyId:this.state.companyId,
                            projectId:0,
                            productId:0,
                            patentId:0,
                            otherId:0,
                            remark:'',
                            url: '/create/'+this.state.companyName+'/企业研发准备金管理制度.pdf',
                            fileName: '企业研发准备金管理制度.pdf'
                        }
                        fetchPostFile(global.constants.previewFile,params)
                            .then(
                                res=>{
                                    res.blob().then(
                                        blob=> {
                                            let blobUrl = window.URL.createObjectURL(blob);
                                            this.setState(()=>({
                                                fileStream:blobUrl,
                                                preview_visible:true,
                                            }))
                                        })
                                }
                            )
                    }else{
                        message.info("云端不存在该文件，请先生成！").then()
                    }
                }
            )
    }
    hideModalTwo(){
        this.setState(()=>({
            uploadFile_visible:false,
        }))
    }
    handleUploadClick(e){
        this.setState(()=>({
            upload_visible:true,
        }))
        let params = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:0,
            otherId:0,
            remark:'企业研发准备金管理制度',
            url:'',
        }
        fetchPost(global.constants.checkFile, params)
            .then(
                res => {
                    if(res.code === 200){
                        let params = {
                            companyId:this.state.companyId,
                            projectId:0,
                            productId:0,
                            patentId:0,
                            otherId:0,
                            remark:'企业研发准备金管理制度',
                            url: '',
                            fileName: ''
                        }
                        fetchPostFile(global.constants.previewFile,params)
                            .then(
                                res=>{
                                    res.blob().then(
                                        blob=> {
                                            let blobUrl = window.URL.createObjectURL(blob);
                                            this.setState(()=>({
                                                fileStream_upload:blobUrl,
                                                checkStatus:true
                                            }))
                                        })
                                }
                            )
                    }
                    else{
                        this.setState(()=>({
                            fileStream_upload:'',
                            checkStatus:false,
                        }))
                    }
                })
    }
    fileInput(){
        this.setState(()=>({
            fileField:document.querySelector("input[type='file'][name='file']"),
            uploadFile_visible:true,
        }))
    }
    uploadFile(){
        const formdata = new FormData();
        formdata.append('file', this.state.fileField.files[0]);
        formdata.append('companyId',this.state.companyId);
        formdata.append('projectId',0);
        formdata.append('productId',0);
        formdata.append('patentId',0);
        formdata.append('otherId',0);
        formdata.append('remark','企业研发准备金管理制度');
        if (!(/pdf$/i.test(this.state.fileField.files[0].name))) {
            alert("只允许上传pdf格式的文件")
        } else{
            fetch(global.constants.uploadFile, {
                method: 'POST',
                body: formdata,
                mode: 'cors',
                credentials: 'include',
            })
                .then(res => res.json())
                .then(
                    res => {
                        if(res.code === 200){
                            message.success("上传成功").then();
                            let params = {
                                companyId:this.state.companyId,
                                projectId:0,
                                productId:0,
                                patentId:0,
                                otherId:0,
                                remark:'企业研发准备金管理制度',
                                url: '',
                                fileName: ''
                            }
                            fetchPostFile(global.constants.previewFile,params)
                                .then(
                                    res=>{
                                        res.blob().then(
                                            blob=> {
                                                let blobUrl = window.URL.createObjectURL(blob);
                                                this.setState(()=>({
                                                    fileStream_upload:blobUrl,
                                                    uploadFile_visible:false,
                                                    checkStatus:true,
                                                }))
                                            })
                                    }
                                )
                        }
                    })
        }
    }
    deleteUpload(){
        let params = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:0,
            otherId:0,
            remark:'企业研发准备金管理制度',
            url: '',
        }
        fetchPost(global.constants.deleteFile,params)
            .then(
                res=>{
                    if(res.code === 200){
                        message.success("删除成功").then()
                        this.setState(()=>({
                            checkStatus:false,
                        }))
                    }
                }
            )
    }
    render() {
        const Anchor = props => {
            return (
                <a {...props}>{props.children}</a>
            );
        };
        return (
            <div>
                <Anchor id="downloadDiv" style={{display: 'none'}}/>
                <div className="content-page-header">
                    <PageHeader
                        ghost={false}
                        title="企业研发准备金管理制度"
                        subTitle='可编辑生成或上传，只允许上传50M以内的pdf格式的文件'
                        extra={[
                            <Button type="primary"  onClick={this.handleUploadClick.bind(this)}>上传</Button>,
                            <Button
                                onClick={this.handleExportClick.bind(this)}>生成</Button>,
                            <Tooltip title="预览生成的文件">
                                <Button
                                    type="primary"
                                    onClick={this.handlePreviewClick.bind(this)}
                                >预览</Button>
                            </Tooltip>,
                        ]}
                    >
                    </PageHeader>
                </div>
                <div>
                    <Paragraph>
                        <pre>注：若两种方式的文件均存在，文件合成时系统自动选取上传的文件。</pre>
                    </Paragraph>
                </div>
                <div className="content-frame-wordStyle">
                    <div className="content-form-wordStyle">
                        <Space direction="vertical" >
                            <Typography>
                                <Paragraph className="word">
                                    <Paragraph className="word-title">企业研发准备金管理制度</Paragraph>
                                </Paragraph>
                                <Paragraph >
                                    <span className="textStyle-bold">
                                        &nbsp; &nbsp; &nbsp;&nbsp;
                                        第一条
                                    </span>
                                    &nbsp;
                                    为规范{this.state.companyName}（以下简称“公司”）的研发费用的预算、支撑管理，特制定本制度。
                                </Paragraph>
                                <Paragraph>
                                    <span className="textStyle-bold">
                                         &nbsp; &nbsp; &nbsp;&nbsp;
                                        第二条
                                    </span>
                                    &nbsp;
                                    公司在产品、技术、材料、工艺、标准的研究、开发过程中发生的 各项费用的管理按本制度执行。
                                </Paragraph>
                                <Paragraph className="textStyle-bold">
                                    第三条 各部门的职责权限：
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    （一）研发部：按研发计划制定并执行各项研发项目的研发预算，有效利用研发经费；
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    （二）财务部：建立研发准备金制度，根据研发计划及费用预算，提前准备资金，
                                    确保研发资金的需求，同时有效的监督研发经费的使用。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    第四条 研发经费的预算管理：
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    （一）公司的研发过程中所产生的费用主要有以下几大类：
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    1、研发过程中直接消耗的材料及辅料；
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    2、用于研发活动的设备、仪器及研发场地的购置费及其折旧和维修费用；
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    3、研发人员的工资及各项奖金（包括在职和外聘）；
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    4、用于研发品制样、试产等所产生的各项费用；
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    5、研发成果的论证、评审、验收、评估以及知识产权申请费、注册费、代 理费等费用：
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    6、与研发活动直接相关的费用（包括技术图书资料费、资料翻译费、会议
                                    费、差旅费、办公费、外事费、研发人员培训费、培养费、专家咨询费、高新科 技保险费等）
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    7、用于其它的研发费；
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    （二）研发部在研发立项时，应同时向公司提报“研发项目资金预算”应按上
                                    述分类详细的列明该研发项目涉及的费用，“研发项目资金预算”应包括 各项经费的需求时间。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    （三）对于研发过程中所需的新材料不明价格的，在列预算时可以根据市场同类产品的价格进行预估，允许20%的预算误差率。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    （四）“研发项目资金预算”由研发项目组编制，经研发部审核后交财务主管及公司总经理审核，并将总经理提批准后的“研发项目资金预 算”交财务部备案，研发部留底。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    （五）财务部接到总经理批准生效的“研发项目资金预算”之后，应据此提前准备研发经费，确保按研发计划提供资金保障。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    第五条 研发经费支出管理：
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    （一）公司实行预算管理的目的是为了确保资金在计划、可控下运作，每个研发项目的费用原则上必须在“研发项目资金预算”下进行；
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    （二）研发材料、设备、仪器、场地等购置或租赁费用支出，外包与外单位合作研发的费用支出必须先进行申请，
                                    财务部接到申请后首先应该审核该项支出是否在预算范围内，在范围内的财务部主管有权予以通过，
                                    所申请的支出财务部应先行在对应的预算中进行扣除，费用实际发生时再予冲抵。如超出预算的财务部不予通过，
                                    并提醒研发部需要走追加预算的流程；
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    （三）研发人员的工资、研发设备的折旧、场地租赁等固定费用由财务部 按结算周期直接从预算中扣除；
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    （四）其它类别的研发费用发生之后，研发部参照公司“财务报销制度”申请报销，
                                    财务部据“研发费用资金预算”进行审核，支出在预算之内的，由部门主管审核，财务部经理及总经理签字后可以报销，
                                    预算之外的费用必须经过公司总经理签核后才能报销，并应进行“追加预算”；
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    （五）研发过程中产生出的不合格产品则要进行回收处理，,减少研发损失，避免环境污染。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    第六条 本制度未尽事宜，按有关法律、行政法规和规范性文件及《{this.state.companyName}章程》的规定执行
                                    。本制度如与国家日后颁布的法律、行政法规和规范性文件或修改后的公司章程相冲突，
                                    按国家有关法律、行政法规和规范性文件及公司章程的规定执行，并及时修订本制度报董事会审议通过。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    第七条 本制度由公司总经理负责解释和修订。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    第八条 本制度经公司总经理审议批准后实施。
                                </Paragraph>
                                <div style={{float:'right',marginRight:'10%'}}>
                                    <Paragraph className="textStyle">
                                        {this.state.companyName}
                                    </Paragraph>
                                    <Paragraph className="textStyle">
                                        {
                                            this.state.status === false?
                                                <Input
                                                    placeholder={'请填写文件时间'}
                                                    defaultValue={this.state.organizationData.time}
                                                    className="input_style"
                                                    onChange={this.timeChange.bind(this)}
                                                />:
                                                this.state.organizationData.time
                                        }
                                    </Paragraph>
                                </div>
                            </Typography>
                            <div>
                                <Button type="primary" className="submit-edit-button" onClick={this.submit.bind(this)}>提交</Button>
                                <Button
                                    disabled={!this.state.status}
                                    type="primary" className="submit-edit-button" onClick={this.edit.bind(this)}>编辑</Button>
                            </div>
                        </Space>
                        <Modal
                            visible={this.state.preview_visible}
                            title={'预览'}
                            onCancel={this.hideModal}
                            destroyOnClose
                            width={'50%'}
                            footer={[
                                <Button key="back" onClick={this.hideModal}>
                                    取消
                                </Button>,
                                <Button key="back"  type="primary" onClick={this.download.bind(this)}>
                                    下载
                                </Button>,
                            ]}
                        >
                            <FileViewer fileType='pdf'
                                        filePath={this.state.fileStream}
                                        onError={this.onError}
                            />
                        </Modal>
                        <Modal
                            visible={this.state.upload_visible}
                            title={'上传附件'}
                            onCancel={this.hideModal.bind(this)}
                            destroyOnClose
                            footer={[
                                <Button key="back" onClick={this.hideModal.bind(this)}>
                                    取消
                                </Button>,
                                <Button key="submit" type="primary" onClick={this.hideModal.bind(this)}>
                                    完成
                                </Button>,
                            ]}
                        >
                            <div>
                                该公司的企业研发准备金管理制度
                                {this.state.checkStatus === true?<Tag color="green" className="Tag_style">已上传</Tag>:<Tag color="red" className="Tag_style">未上传</Tag>}
                                <Form style={{marginTop:'20px'}}>
                                    <Form.Item
                                        name='file'
                                        method="post"
                                        enctype="multipart/form-data"
                                    >
                                        <input
                                            type="file"
                                            name='file'
                                            onChange={this.fileInput.bind(this)}
                                        />
                                    </Form.Item>
                                    <Form.Item name="preview_paper">
                                        {
                                            this.state.checkStatus === true &&
                                            <div>
                                                <Button type={"primary"} onClick={this.deleteUpload.bind(this)}>删除</Button>
                                                <FileViewer fileType='pdf'
                                                            filePath={this.state.fileStream_upload}
                                                            onError={this.onError}
                                                />
                                            </div>
                                        }
                                    </Form.Item>
                                </Form>
                            </div>
                        </Modal>
                        <Modal
                            visible={this.state.uploadFile_visible}
                            title={'上传'}
                            onCancel={this.hideModalTwo.bind(this)}
                            destroyOnClose
                            footer={[
                                <Button key="back" onClick={this.hideModalTwo.bind(this)}>
                                    取消
                                </Button>,
                                <Button key="submit" type="primary" onClick={this.uploadFile.bind(this)}>
                                    确定
                                </Button>,
                            ]}
                        >
                            <div>确定上传该企业研发准备金管理制度吗？</div>
                        </Modal>
                    </div>
                </div>
            </div>
        )
    }
}

export default ReserveFund;